import Factory from "@/factories/Factory.ts";
import type { Ledger } from "@/types/account";

interface LedgerResource {
  colour: string;
  id: number;
  is_default: boolean;
  name: string;
}

class LedgerFactory extends Factory<Ledger, LedgerResource> {
  public fromJson(resource: LedgerResource): Ledger {
    return {
      colour: resource.colour,
      id: resource.id,
      isDefault: resource.is_default,
      name: resource.name,
    };
  }
}

export { LedgerFactory, type LedgerResource };
